/* TARAYA site-wide behaviour. Loaded on every page.
   1. Input-modality flag for focus rings.
   2. Lazy-image fade-in.
   3. Contact form: name (and optionally phone) required.
   4. Homepage featured product: image links to the product page. */

(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- 1. Input modality ----------
     Programmatic focus (for example the cart icon after the drawer closes)
     counts as :focus-visible in browsers, so header icons showed a ring
     after mouse use. <html> gets .taraya-pointer while a mouse or touch was
     the last input; brand-taraya.css suppresses the header-icon ring only
     in that state. Any key press removes the flag. If this script fails,
     rings simply show: the safe failure for keyboard and screen-reader users. */
  var root = document.documentElement;
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, function () { root.classList.add('taraya-pointer'); }, { capture: true, passive: true });
  });
  window.addEventListener('keydown', function () { root.classList.remove('taraya-pointer'); }, true);

  /* ---------- 2. Lazy-image fade ----------
     Only lazy images that are not yet loaded get the pending class, so
     cached images never flash. Errors clear the class so nothing stays
     invisible. */
  function initLazyFade() {
    document.querySelectorAll("img[loading='lazy']").forEach(function (img) {
      if (img.complete) return;
      img.classList.add('taraya-img-pending');
      img.addEventListener('load', function () {
        img.classList.add('taraya-img-loaded');
        img.classList.remove('taraya-img-pending');
      }, { once: true });
      img.addEventListener('error', function () {
        img.classList.remove('taraya-img-pending');
      }, { once: true });
    });
  }

  /* ---------- 3. Contact form ----------
     Shopify's /contact endpoint only enforces email. Name is made required
     here. Phone is required while REQUIRE_PHONE is true (the current
     behaviour); set it to false to make phone optional. Either way the pattern accepts 8 to 15 digits with separators.
     This is browser-side validation only; Shopify does not enforce it. */
  var REQUIRE_PHONE = true;

  function initContact() {
    var name = document.getElementById('ContactForm-name');
    var phone = document.getElementById('ContactForm-phone');
    var required = [name];
    if (REQUIRE_PHONE) required.push(phone);
    required.forEach(function (el) {
      if (!el) return;
      el.required = true;
      el.setAttribute('aria-required', 'true');
      var label = document.querySelector('label[for="' + el.id + '"]');
      if (label && label.textContent.indexOf('*') === -1) label.textContent = label.textContent.trim() + ' *';
    });
    if (phone) {
      phone.setAttribute('inputmode', 'tel');
      phone.setAttribute('pattern', '(?:[+\\(\\)\\-\\s]*\\d){8,15}[+\\(\\)\\-\\s]*');
      phone.setAttribute('title', 'Enter a phone number with 8 to 15 digits');
    }
  }

  /* ---------- 4. Featured product image link ----------
     Origin's featured-product section links only its "View full details"
     text. This lays a link over the image to the same product page. It is
     kept out of the tab order and hidden from screen readers because the
     text link already provides the same destination for them. */
  function initFeaturedLinks() {
    document.querySelectorAll('.featured-product').forEach(function (fp) {
      var info = fp.querySelector('.product__info-container[data-url]');
      var url = info && info.getAttribute('data-url');
      if (!url) return;
      var media = fp.querySelector('.product__media-wrapper .product__media-item') || fp.querySelector('.product__media-wrapper');
      if (!media || media.querySelector('.taraya-media-link')) return;
      var a = document.createElement('a');
      a.className = 'taraya-media-link';
      a.href = url;
      a.tabIndex = -1;
      a.setAttribute('aria-hidden', 'true');
      media.classList.add('taraya-media-linked');
      media.appendChild(a);
    });
  }

  onReady(function () {
    initLazyFade();
    initContact();
    initFeaturedLinks();
  });
  document.addEventListener('shopify:section:load', initFeaturedLinks);
})();
